<template>
  <div v-if="ttns.length" @click.stop="openModal">
    <el-row
      v-for="ttn in ttns"
      :key="ttn.id"
      :class="[
        'response-ttns',
        response['ttn-status'],
        { 'text-align-left': value },
      ]"
      v-html="getTTNInfo(ttn)"
    />
  </div>
  <div v-else class="response-act danger">ТТН</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Ttns',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    onTTNClick: {
      type: Function,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getTtns: 'reports/getReportModal',
    }),
    ttns() {
      return this.getTtns(this.response.id, 'ttns')
    },
  },
  methods: {
    getTTNInfo(ttn) {
      const label = this.value ? '<span class="label">ТТН:</span> ' : 'ТТН '
      const { number, date } = ttn
      const day = this.dateToFormat(date, 'shortDateWithoutYear')

      return number && day ? `${label} ${number} от ${day}` : ''
    },
    openModal() {
      this.onTTNClick(this.response)
    },
  },
}
</script>

<style lang="sass">
.report-response-item
  & .response-ttns
    font-weight: bold
    position: relative
    text-align: center
    cursor: pointer
    font-size: 14px
    & .label
      color: #A4A4A4
    &.danger
      color: #f00
    &.warning
      color: #ffb800
    &.success
      color: #00bf40
    .act-badge
      &:after
        content: ''
        position: absolute
        background: url('~@/assets/img/sign-badge.png')
        width: 13px;
        height: 15px;
        top: -10px;
        right: -10px;
        background-size: cover;
</style>
